import { render, staticRenderFns } from "./ProfilePM.vue?vue&type=template&id=30fcb184&scoped=true&lang=pug&"
import script from "./ProfilePM.vue?vue&type=script&lang=js&"
export * from "./ProfilePM.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePM.vue?vue&type=style&index=0&id=30fcb184&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fcb184",
  null
  
)

export default component.exports